<template>
  <div class="pad-10">
    <div class="panel panel-default panel-table" v-if="initialised">
      <div class="panel-heading">
        <div class="row">
          <div class="col col-xs-6 col-md-8">
            <h3 class="panel-title">{{ tableTitle }}</h3>
          </div>
          <div class="col col-xs-6 col-md-4 text-right" v-if="showCount">
            <div style="display: inline-block;" class="form-inline">
              <label :for="'vuetable-' + _uid" class="form-label hidden-xs">
                Per page
              </label>
              <select @change="resetPage" class="form-control" :id="'vuetable-' +_uid" v-model="resultsPerPage">
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="500">500</option>
              </select>
            </div>
            <div style="display: inline-block;" class="btn btn-primary sq" @click="showSettings = !showSettings">
              <i class="fa fa-cog"></i>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6" style="padding-top: 10px; padding-bottom: 10px;">
            <div class="pull-right">
              <div
                class="input-group"
                data-toggle="tooltip"
                title="This will filter against all values within the item, not just those on display! This is limited to 500 records maximum">
                <input :disabled="tableData.length > 500" type="text" placeholder="Filter results" class="form-control" v-model="searchText"/>
                <span class="input-group-addon" @click="searchText = ''">
                  <i class="fa fa-times"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6" style="padding-top: 10px; padding-bottom: 10px;">
            <div v-if="showSelectAll" class="pull-right" style="width:100%">
              <div v-if="promptSelectAll === false" style="width:100%" @click="promptSelectAll = true" :class="selectAllBtnClasses">
                {{ selectAllAction || 'Delete' }} {{ tableData.filter(({selected}) => selected).length }} selected item(s)
              </div>
              <div v-if="promptSelectAll === true" >
                This will {{ selectAllAction || 'Delete' }} {{ tableData.filter(({selected}) => selected).length }} item(s)
              </div>
              <div v-if="promptSelectAll === true" class="btn btn-success sq" style="width:49.5%" @click="$emit('select-all', tableData.filter(({selected}) => selected)); promptSelectAll = false">
                Confirm
              </div>
              <div v-if="promptSelectAll === true" class="btn btn-danger sq" style="width:49.5%" @click="promptSelectAll = false">
                Cancel
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6" style="padding-top: 10px; padding-bottom: 10px;">
            <slot name="head-slot"></slot>
          </div>
        </div>
      </div>
      <div class="panel-body" style="position: relative;">
        <div :class="[showSettings ? 'open' : '', 'table-settings']">
          <h4 style="padding:10px;">Visible columns</h4>
          <div class="row" style="background:#eee;padding:10px;">
            <div class="col-xs-12 col-sm-6 col-md-3" v-for="(field, i) in fields" :key="i">
              <div class="form-group">
                <label :for="'is-state' + i" class="form-label">{{ field.header }}</label>
                <div class="material-switch">
                  <input :true-value="false" :false-value="true" :id="'is-state' + i" type="checkbox" v-model="field.hideByDefault"/>
                  <label :for="'is-state' + i" class="label-success"></label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered table-list">
            <thead class="pointer" data-toggle="tooltip" data-title="Click to sort by column" >
            <tr>
              <th v-if="canModify || hasSlot" :class="iconColumnClass"></th>
              <th v-if="hasSpecialSlot" :class="iconColumnClass">
                <slot name="specialSlotHeader" />
              </th>
              <th v-if="allowSelect" @click="selectAll">Select <i class="fa fa-hand-o-up"></i></th>
              <th v-for="(field, i) in fields" v-if="!field.hideByDefault" @click="sort(field, i)">
                {{ field.header }}
                <span v-if="i === sortHeaderActive">
                  <i :class="[ sortType === 'asc' ? 'fa-chevron-up' : 'fa-chevron-down', 'fa' ]"></i>
                </span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, i) in visibleItems">
              <td :class="iconColumnClass" align="center" v-if="(canModify && indexToDelete !== i) || (hasSlot && indexToDelete !== i)">
                <slot name="icons" :item="item" :index="i" />
                <a data-toggle="tooltip" title="Edit" v-if="showEdit"  class="btn btn-default" @click="emitEdit(item, i)">
                  <em class="fa fa-pencil"></em>
                </a>
                <a data-toggle="tooltip" title="Clone" v-if="showClone"  class="btn btn-primary" @click="emitClone(item, i)">
                  <em class="fa fa-clone"></em>
                </a>
                <a data-toggle="tooltip" title="Delete" v-if="showDelete"  class="btn btn-danger" @click="promptDelete(item, i)">
                  <em class="fa fa-trash"></em>
                </a>
              </td>
              <td align="center" v-if="hasSpecialSlot">
                <slot name="specialSlot" :item="item" :index="i" />
              </td>
              <td class="can-mod" align="center" v-if="canModify && indexToDelete === i">
                <div><small>Delete</small></div>
                <a class="btn btn-danger" @click="emitDelete(item, i)"><i class="fa fa-check"></i></a>
                <a class="btn btn-success" @click="cancelDelete"><i class="fa fa-times"></i></a>
              </td>

              <!--
                HACK - needed ability to allow dynamic router link from outside of component
                if data item is of format prop: function then this is evaluated in the top
                example below. If prop is type {} with isRouteLink === true then prop.link
                must be a function
              -->
              <td v-if="allowSelect">
                <div class="form-group height-cap">
                  <div class="material-switch">
                    <input :id="'allow-select-' + i" type="checkbox" v-model="item.selected"/>
                    <label :for="'allow-select-' + i" class="label-success"></label>
                  </div>
                </div>
              </td>
              <td v-for="field in fields" v-if="typeof field.prop !== 'object' && !field.hideByDefault" :class="{ 'text-align-right': field.hasOwnProperty('numericalField') }">
                <pulse-loader :size="'5px'" v-if="field.showLoadIfNull && (evaluateProperty(item, field) === null)"></pulse-loader>
                {{ evaluateProperty(item, field) }} <span v-if="hasTooltip(item, field)" :title="evaluateTooltip(item, field)">*</span>
              </td>
              <!--
              -->

            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="panel-footer">
        <div class="row">
          <div class="col col-xs-6 sml-font">
            <span v-if="!usePages" data-html="#load-tip" v-tippy="{ position: 'top', arrow: true, inertia: true, size: 'large' }">{{ minItemVisible }} to {{ maxItemVisible }} of {{ getItemsLength }}</span>
            <span v-else-if="usePages" data-html="#load-tip" v-tippy="{ position: 'top', arrow: true, inertia: true, size: 'large' }">{{ pageMessage }}</span>
            <span class="option-info" data-html="#load-tip">
              <div id="load-tip" style="display:none;">
                {{ loadTip }}
              </div>
            </span>
          </div>
          <div class="col col-xs-6">
            <ul class="pagination pull-right">
              <li :class="[ page === 1 && !pageNumber ? 'disabled' : '' ]"><a @click="reducePage">«</a></li>
              <li :class="[ !canIncrease ? 'disabled' : '' ]"><a @click="increasePage">»</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import PulseLoader from './PulseLoader.vue'
  import IEHackMixin from './IEHackMixin'
  export default {
    name: 'VueTable',
    mixins: [IEHackMixin],
    props: ['tableData', 'showEdit', 'showDelete', 'showClone', 'fields', 'tableTitle', 'hasSlot', 'hasSpecialSlot', 'showSelectAll', 'selectAllAction', 'selectAllBtnClass', 'allowSelect', 'maxItems', 'countVisible', 'usePages', 'pageNumber'],
    data () {
      return {
        resultsPerPage: 500,
        search: '',
        page: 1,
        indexToDelete: null,
        itemToDelete: null,
        searchText: '',
        sortProp: null,
        showNumericalSort: false,
        sortType: 'asc',
        sortHeaderActive: null,
        sorted: [],
        promptSelectAll: false,
        selected: [],
        allSelected: false,
        visibleFields: [],
        showSettings: false,
        initialised: false
      }
    },
    components: {
      PulseLoader
    },
    watch: {
      tableDataFiltered: {
        deep: true,
        handler: function (newVal, oldVal) {
          if (newVal.length < oldVal.length) {
            this.page = 1
          }
        }
      },
      sortedData: {
        deep: true,
        handler: function (newVal, oldVal) {
          this.$emit('filtering-or-sorting', newVal)
        }
      }
    },
    methods: {
      setUp () {
        this.fields.forEach(obj => {
          if (!obj.hasOwnProperty('hideByDefault')) {
            this.$set(obj, 'hideByDefault', false)
          }
        })
        this.initialised = true
      },
      selectAll () {
        this.sortedData.forEach(item => {
          item.selected = !this.allSelected
        })
        this.allSelected = !this.allSelected
      },
      updateSelect (e, item) {
        let index = this.sorted.findIndex(({id}) => id === item.id)
        if (e.target.checked && index === -1) {
          this.sorted.push(item)
        } else if (!e.target.checked && index > -1) {
          this.sorted.splice(index, 1)
        }
      },
      evaluateProperty (item, field) {
          /*
            hack added to allow router-link although top
            statement should never be triggered as
            catered for in html
           */
        const prop = field.prop
        if (typeof prop === 'object' && prop.isRouteLink) {
          return
        } else if (typeof prop === 'function') {
          if (field.hasOwnProperty('numericalField') && field.numericalField && !this.isNumberFormatDisabled) {
            return this.numberFormat(prop(item))
          }
          return prop(item)
        } else if (item.hasOwnProperty(prop)) {
          if (field.hasOwnProperty('numericalField') && field.numericalField && !this.isNumberFormatDisabled) {
            return this.numberFormat(item[prop])
          } else {
            return item[prop]
          }
        }
        return prop
      },
      evaluateTooltip (item, field) {
        const tooltip = field.tooltip
        if (typeof tooltip === 'function') {
          return tooltip(item)
        } else if (item.hasOwnProperty(tooltip)) {
          return item[tooltip]
        }
        return tooltip
      },
      hasTooltip (item, field) {
        return field.hasOwnProperty('tooltip') && this.evaluateTooltip(item, field)
      },
      emitEdit (item, index) {
        this.$emit('table-edit-request', { item: item, index: index })
      },
      emitClone (item, index) {
        this.$emit('table-clone-request', { item: item, index: index })
      },
      emitDelete (item, index) {
        this.$emit('table-delete-request', { item: item, index: index })
        this.cancelDelete()
      },
      cancelDelete () {
        this.itemToDelete = null
        this.indexToDelete = null
      },
      promptDelete (item, index) {
        this.indexToDelete = index
        this.itemToDelete = item
      },
      reducePage () {
        this.page = this.page <= 1 ? 1 : this.page - 1
        this.$emit('page-back')
      },
      resetPage () {
        this.page = 1
        this.cancelDelete()
      },
      increasePage () {
        this.cancelDelete()
        this.page = this.page >= this.maxPageNumber ? this.maxPageNumber : this.page + 1
        this.$nextTick(this.emitProgress)
      },
      emitProgress () {
        this.$emit('pages-remaining', {
          remaining: this.maxPageNumber - this.page,
          page: this.page,
          maxPage: this.maxPageNumber
        })
      },
      reCalibrate () {
        this.indexToDelete = null
        this.itemToDelete = null
      },
      sort (field, index) {
        this.showNumericalSort = field.hasOwnProperty('numericalField') && field.numericalField
        this.sortType = this.sortType === 'asc' ? 'desc' : 'asc'
        this.sortProp = field.prop
        this.sortHeaderActive = index
      },
      sortByString () {
        return this.tableDataFiltered.slice(0).sort((a, b) => {
          let valA = a[this.sortProp] === null ? '' : String(a[this.sortProp]).toLowerCase()
          let valB = b[this.sortProp] === null ? '' : String(b[this.sortProp]).toLowerCase()
          if (this.sortType === 'asc') {
            return valA < valB ? -1 : valA > valB ? 1 : 0
          } else {
            return valB < valA ? -1 : valB > valA ? 1 : 0
          }
        })
      },
      sortByFunction () {
        return this.tableDataFiltered.slice(0).sort((a, b) => {
          let valA = this.sortProp(a) === null ? '' : String(this.sortProp(a)).toLowerCase()
          let valB = this.sortProp(b) === null ? '' : String(this.sortProp(b)).toLowerCase()
          if (this.sortType === 'asc') {
            return valA < valB ? -1 : valA > valB ? 1 : 0
          } else {
            return valB < valA ? -1 : valB > valA ? 1 : 0
          }
        })
      },
      sortByNumber () {
        return this.tableDataFiltered.slice(0).sort((a, b) => {
          let valA = a[this.sortProp] === null ? 0 : parseFloat(a[this.sortProp])
          let valB = b[this.sortProp] === null ? 0 : parseFloat(b[this.sortProp])
          if (this.sortType === 'asc') {
            return valA < valB ? -1 : valA > valB ? 1 : 0
          } else {
            return valB < valA ? -1 : valB > valA ? 1 : 0
          }
        })
      }
    },
    computed: {
      pageMessage () {
        return `Page ${this.pageNumber || this.page} of ${this.maxItemPage}`
      },
      maxItemPage () {
        return Math.ceil(this.maxItems / this.resultsPerPage)
      },
      showCount () {
        return this.countVisible !== false
      },
      selectAllBtnClasses () {
        let str = 'btn sq '
        return this.selectAllBtnClass ? str + this.selectAllBtnClass : str + ' btn-danger'
      },
      canIncrease () {
        return this.page < this.maxPageNumber || (this.maxItems && (this.tableData.length < this.maxItems))
      },
      loadTip () {
        return this.maxValue ? `${this.tableData.length} of ${this.maxValue} loaded` : ''
      },
      getItemsLength () {
        return this.maxValue || this.tableDataFiltered.length
      },
      maxValue () {
        return this.maxItems || null
      },
      tableDataFiltered () {
        return this.searchText.trim().length === 0 ? this.tableData : this.tableData.filter(obj => {
          let re = new RegExp(this.searchText, 'gi')
          return JSON.stringify(obj).match(re) !== null
        })
      },
      minItemVisible () {
        return !this.tableDataFiltered.length ? 0 : this.beginIndexOfVisibleItems + 1
      },
      maxItemVisible () {
        return !this.tableDataFiltered.length ? 0 : this.lastIndexOfVisibleItems + 1
      },
      maxPageNumber () {
        return Math.ceil(this.tableDataFiltered.length / this.resultsPerPage)
      },
      pages () {
        let arr = []
        for (let i = 1; i <= this.maxPageNumber; i++) {
          arr.push(i)
        }
        return arr
      },
      canModify () {
        return this.showEdit || this.showDelete
      },
      beginIndexOfVisibleItems () {
        return (this.resultsPerPage * this.page) - this.resultsPerPage
      },
      lastIndexOfVisibleItems () {
        let lastPossibleIndex = (this.resultsPerPage * this.page) - 1
        let lastItemIndex = this.tableDataFiltered.length - 1
        return lastPossibleIndex > lastItemIndex ? lastItemIndex : lastPossibleIndex
      },
      sortedData () {
        let toReturn = this.tableDataFiltered
        if (this.sortProp === null) {
          toReturn = this.tableDataFiltered
        } else if (this.showNumericalSort) {
          toReturn = this.sortByNumber()
        } else if (typeof this.sortProp === 'string') {
          toReturn = this.sortByString()
        } else if (typeof this.sortProp === 'function') {
          toReturn = this.sortByFunction()
        }
        return toReturn
      },
      visibleItems () {
        let arr = []
        for (let i = this.beginIndexOfVisibleItems; i <= this.lastIndexOfVisibleItems; i++) {
          arr.push(this.sortedData[i])
        }
        return arr
      },
      iconColumnClass () {
        return this.showEdit && this.showDelete && (this.showClone || this.$scopedSlots.icons) ? 'can-mod-ex' : 'can-mod'
      },
      isNumberFormatDisabled () {
        return !!this.$store.getters['systemOption/defaultEnabled']('DISABLE_NUMBER_FORMAT')
      }
    },
    mounted () {
      this.$parent.$on('calibrate-table', this.reCalibrate)
      this.setUp()
    },
    beforeDestroy () {
      this.$parent.$off('calibrate-table', this.reCalibrate)
    }
  }
</script>

<style scoped>
  .panel-table .panel-body{
    padding:0;
  }

  .panel-table .panel-body .table-bordered{
    border-style: none;
    margin:0;
  }

  .panel-table .panel-body .table-bordered > thead > tr > th:first-of-type {
    text-align:center;
    /* width: 100px; */
  }

  .panel-table .panel-body .table-bordered > thead > tr > th:last-of-type,
  .panel-table .panel-body .table-bordered > tbody > tr > td:last-of-type {
    border-right: 0px;
  }

  .panel-table .panel-body .table-bordered > thead > tr > th:first-of-type,
  .panel-table .panel-body .table-bordered > tbody > tr > td:first-of-type {
    border-left: 0px;
  }

  .panel-table .panel-body .table-bordered > tbody > tr:first-of-type > td{
    border-bottom: 0px;
  }

  .panel-table .panel-body .table-bordered > thead > tr:first-of-type > th{
    border-top: 0px;
  }

  .panel-table .panel-footer .pagination{
    margin:0;
  }
  .can-mod {
    width: 100px;
  }
  .can-mod-ex {
    width: 150px;
  }
  /*
  used to vertically center elements, may need modification if you're not using default sizes.
  */
  .panel-table .panel-footer .col{
    line-height: 34px;
    height: 34px;
  }

  .panel-table .panel-heading .col h3{
    line-height: 30px;
    height: 30px;
  }

  .panel-table .panel-body .table-bordered > tbody > tr > td{
    line-height: 34px;
  }

  td {
    word-break: break-all;
  }
  .pagination > li {
    cursor: pointer;
  }
  .form-group.height-cap {
    margin-bottom: 0 !important;
  }
  .form-group.height-cap .material-switch {
    padding-bottom: 0 !important;
    padding-top: 0 !important;
  }
  .table-settings {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    padding: 0;
    max-height: 0;
    transition: all 0.5s;
    overflow: hidden;
    z-index: 9999;
  }
  .table-settings.open {
    max-height: 1000px;
    margin: 10px;
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
  }
  .text-align-right {
    text-align: right;
    padding-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/modules/helpers/VueTable.vue